import { useState } from 'react';
import { useAuth } from 'shared/hooks/useAuth';
import { useAsyncData } from 'shared/hooks/useAsyncData';
import { fetchClassGroups, saveSessionAttendance } from 'modules/arena/class-groups/classGroupsService';
import { ClassGroup } from 'modules/arena/class-groups/types';

export function useInstructorClasses() {
  const { user } = useAuth();
  const { data: allGroups, isLoading, error, setData: setAllGroups } = useAsyncData<ClassGroup[]>(
    fetchClassGroups,
    []
  );
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [expandedSessionId, setExpandedSessionId] = useState<string | null>(null);

  const myGroups = allGroups.filter((group) => group.instructor === user?.name);
  const selectedGroup = myGroups.find((group) => group.id === selectedId) ?? myGroups[0] ?? null;

  function toggleExpandSession(sessionId: string) {
    setExpandedSessionId((prev) => (prev === sessionId ? null : sessionId));
  }

  function togglePresence(sessionId: string, studentId: string) {
    setAllGroups((prev) =>
      prev.map((group) => ({
        ...group,
        upcomingSessions: group.upcomingSessions.map((session) =>
          session.id !== sessionId
            ? session
            : {
                ...session,
                presentStudentIds: session.presentStudentIds.includes(studentId)
                  ? session.presentStudentIds.filter((id) => id !== studentId)
                  : [...session.presentStudentIds, studentId],
              }
        ),
      }))
    );
  }

  function saveAttendance(sessionId: string) {
    setAllGroups((prev) =>
      prev.map((group) => ({
        ...group,
        upcomingSessions: group.upcomingSessions.map((session) =>
          session.id !== sessionId ? session : { ...session, attendanceTaken: true }
        ),
      }))
    );
    setExpandedSessionId(null);

    const session = allGroups.flatMap((group) => group.upcomingSessions).find((item) => item.id === sessionId);
    if (session) saveSessionAttendance(sessionId, session.presentStudentIds).catch(() => {});
  }

  return {
    myGroups,
    isLoading,
    error,
    selectedId: selectedGroup?.id ?? null,
    setSelectedId,
    selectedGroup,
    expandedSessionId,
    toggleExpandSession,
    togglePresence,
    saveAttendance,
  };
}
